import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { selectSiteUrl } from 'core/selectors/app';
import { redirectToTargetLandingPage } from 'core/utils/helpers/redirectToTargetLandingPage';

function RedirectToTargetLandingPage({ children }) {
  const siteUrl = useSelector(selectSiteUrl);
  const redirected = redirectToTargetLandingPage({}, siteUrl);

  if (redirected) {
    return null;
  }

  return children;
}

RedirectToTargetLandingPage.propTypes = {
  children: PropTypes.node.isRequired,
};

export default RedirectToTargetLandingPage;
